'use client';

import { useTheme } from '@/app/components/Theme';
import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { toast } from 'react-toastify';

// Disable static generation for this page since it uses client-side hooks
export const dynamic = 'force-dynamic';

const ContactPage = () => {
  const { isDarkMode } = useTheme();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [captchaValue, setCaptchaValue] = useState<string | null>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!captchaValue) {
      toast.error('Please complete the captcha.');
      return;
    }

    const response = await fetch('/api/sendEmail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        senderEmail: formData.email,
        subject: 'Naozz Trainme App Contact Form Submission',
        message: `Naozz Trainme app has received a new contact form submission from ${formData.name} with email ${formData.email}. \n\nMessage:\n\n${formData.message}`,
      }),
    });

    if (response.status === 200) {
      toast.success('Email sent successfully!');
    } else {
      toast.error('Failed to send email.');
    }
  };

  return (
    <div className='container mx-auto max-w-screen-lg p-4'>
      <h1 className='h1 font-bold my-8'>Contact Us</h1>
      <p className='mb-4'>
        We appreciate your interest in reaching out to us! Please take a moment
        to fill out the form below, as it will help us connect with you and
        address any questions or feedback you may have.
      </p>
      <form className='space-y-8' onSubmit={handleSubmit}>
        <div>
          <label htmlFor='name' className='block font-medium my-2'>
            Name
          </label>
          <input
            type='text'
            id='name'
            name='name'
            required
            className='border border-gray-300 rounded-md p-2 w-full'
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor='email' className='block font-medium my-2'>
            Email
          </label>
          <input
            type='email'
            id='email'
            name='email'
            required
            className='border border-gray-300 rounded-md p-2 w-full'
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor='message' className='block font-medium my-2'>
            Message
          </label>
          <textarea
            id='message'
            name='message'
            required
            rows={20}
            className='border border-gray-300 rounded-md p-2 w-full'
            onChange={handleChange}
          ></textarea>
        </div>
        <ReCAPTCHA
          sitekey={process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_SITE_KEY || ''}
          onChange={setCaptchaValue}
          theme={isDarkMode ? 'dark' : 'light'}
        />
        <button
          type='submit'
          className='bg-blue-500 text-white rounded-md px-4 py-2 hover:bg-blue-600'
        >
          Send Message
        </button>
      </form>
    </div>
  );
};

export default ContactPage;
